export default "__VITE_ASSET__DHEJMjN0__"